/**
 * Bellascena Quick Add — kies je maat en kleur zonder de lade te verlaten.
 *
 * Elk element met data-bc-qa-open="<producthandle>" opent het paneel. De inhoud
 * komt van de Section Rendering API:
 *
 *     /products/<handle>?section_id=bellascena-quick-add-panel
 *
 * Dus geen nagebouwde kaart: het is dezelfde Liquid als de productpagina. De
 * kleurstalen, de prijsopmaak van de markt en de vertalingen komen daardoor
 * vanzelf goed, zonder dat deze code daar iets van hoeft te weten.
 *
 * Waarom dit bestaat: de aanbevelingen in de winkelwagenlade legden blind de
 * eerste beschikbare variant in de wagen. Bij een bh met 23 maten kreeg de klant
 * dus 70A, wat hij ook wilde — en dat merkte hij pas bij de bezorging.
 */
(function () {
  'use strict';

  var root = document.getElementById('bc-quick-add');
  if (!root) return;

  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('bc-quick-add-config').textContent);
  } catch (e) {
    cfg = {};
  }

  // routes.root_url geeft "/nl-nl" zonder slash, en "/" op de hoofdmarkt.
  // Zonder deze normalisatie wordt de URL "/nl-nlproducts/...".
  var ROOT = (cfg.root || '/').replace(/\/*$/, '/');
  var SECTIE = 'bellascena-quick-add-panel';

  var body = root.querySelector('[data-qa-body]');
  var opener = null;        // knop waar we vandaan kwamen, voor focus-herstel
  var varianten = [];
  var gekozen = {};         // positie -> waarde
  var aantal = 1;
  var cache = {};
  var getoondeMedia = null;

  function tekst(sleutel) {
    // Liquid heeft deze teksten al ge-escaped; nog een keer zou &#39; opleveren.
    return Object.prototype.hasOwnProperty.call(cfg.strings || {}, sleutel)
      ? cfg.strings[sleutel] : '';
  }

  /* ── Ophalen ───────────────────────────────────────────────────────── */
  function haal(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTIE)
      .then(function (r) {
        if (!r.ok) throw new Error('niet gevonden');
        return r.text();
      })
      .then(function (html) { cache[handle] = html; return html; });
  }

  /* ── Openen en sluiten ─────────────────────────────────────────────── */
  function open(handle, knop) {
    opener = knop || null;
    getoondeMedia = null;
    root.hidden = false;
    body.innerHTML = '<p class="bc-qa__melding">' + tekst('loading') + '</p>';
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    haal(handle)
      .then(function (html) {
        // De sectie komt als hele pagina terug; we willen alleen het product.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var stuk = doc.querySelector('.bc-qa__product');
        if (!stuk) throw new Error('geen paneelinhoud');
        body.innerHTML = '';
        body.appendChild(stuk);
        naInvoegen();
      })
      .catch(function () {
        body.innerHTML = '<p class="bc-qa__melding">' + tekst('load_error') + '</p>';
      });
  }

  function sluit() {
    root.classList.remove('is-open');
    // pas verbergen als de overgang klaar is, anders springt hij weg
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 260);
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  /* ── Varianten ─────────────────────────────────────────────────────── */
  function naInvoegen() {
    var json = body.querySelector('[data-qa-varianten]');
    try {
      varianten = JSON.parse(json.textContent);
    } catch (e) {
      varianten = [];
    }

    gekozen = {};
    aantal = 1;
    body.querySelectorAll('.bc-qa__waarde.is-gekozen').forEach(function (b) {
      gekozen[b.getAttribute('data-qa-positie')] = b.getAttribute('data-qa-waarde');
    });

    // Een optie met maar één waarde staat niet in de markup; die halen we uit de
    // eerste variant, anders vindt de vergelijking nooit een combinatie.
    if (varianten.length && varianten[0].opties) {
      varianten[0].opties.forEach(function (waarde, i) {
        var positie = String(i + 1);
        if (!body.querySelector('[data-qa-optie="' + positie + '"]')) {
          gekozen[positie] = waarde;
        }
      });
    }
    ververs();
  }

  function huidige() {
    for (var i = 0; i < varianten.length; i++) {
      var v = varianten[i];
      var raak = true;
      for (var k = 0; k < v.opties.length; k++) {
        if (gekozen[String(k + 1)] !== v.opties[k]) { raak = false; break; }
      }
      if (raak) return v;
    }
    return null;
  }

  function ververs() {
    var knop = body.querySelector('[data-qa-toevoegen]');
    if (!knop) return;
    var knoptekst = knop.querySelector('[data-qa-knoptekst]');
    var v = huidige();

    // Alles gekozen? Zo niet, dan vragen we daar eerst om in plaats van een
    // willekeurige variant toe te voegen — dat was precies de fout die dit
    // paneel moest oplossen.
    var groepen = body.querySelectorAll('[data-qa-optie]');
    var gedaan = 0;
    groepen.forEach(function (g) {
      if (gekozen[g.getAttribute('data-qa-optie')]) gedaan++;
    });

    if (gedaan < groepen.length) {
      knop.disabled = true;
      if (knoptekst) knoptekst.textContent = tekst('select_options');
    } else if (!v || !v.beschikbaar) {
      knop.disabled = true;
      if (knoptekst) knoptekst.textContent = tekst('sold_out');
    } else {
      knop.disabled = false;
      if (knoptekst) knoptekst.textContent = tekst('add_to_cart');
      knop.setAttribute('data-qa-variant', v.id);
    }

    if (v) {
      var prijs = body.querySelector('[data-qa-price]');
      var was = body.querySelector('[data-qa-was]');
      if (prijs) prijs.textContent = v.prijs;
      if (was) {
        if (v.was) { was.textContent = v.was; was.hidden = false; }
        else { was.hidden = true; }
      }
      // De strook springt naar de foto van deze variant.
      if (v.media) toonMedia(v.media);
    }

    // Kleurnaam naast het label bijwerken. De LEEStekst komt uit data-qa-label
    // (vertaald via het metaobject-label, zie bellascena-kleurnaam.liquid); de
    // rauwe waarde blijft de sleutel waar de variant-keuze op matcht.
    body.querySelectorAll('[data-qa-gekozen]').forEach(function (el) {
      var positie = el.getAttribute('data-qa-gekozen');
      var waarde = gekozen[positie];
      if (!waarde) return;
      var knop = body.querySelector('.bc-qa__waarde[data-qa-positie="' + positie + '"][data-qa-waarde="' + (window.CSS && CSS.escape ? CSS.escape(waarde) : waarde) + '"]');
      el.textContent = (knop && knop.getAttribute('data-qa-label')) || waarde;
    });

    // Combinaties die niet meer te krijgen zijn doorstrepen in plaats van
    // verbergen: dan zie je dat de maat bestaat maar op is.
    body.querySelectorAll('.bc-qa__waarde').forEach(function (b) {
      var positie = b.getAttribute('data-qa-positie');
      var proef = {};
      for (var k in gekozen) proef[k] = gekozen[k];
      proef[positie] = b.getAttribute('data-qa-waarde');
      var kan = varianten.some(function (x) {
        for (var i = 0; i < x.opties.length; i++) {
          var p = String(i + 1);
          if (proef[p] && proef[p] !== x.opties[i]) return false;
        }
        return x.beschikbaar;
      });
      b.classList.toggle('is-uitverkocht', !kan);
    });
  }

  function toonMedia(id) {
    if (String(id) === String(getoondeMedia)) return;
    var strook = body.querySelector('[data-qa-media]');
    var doel = body.querySelector('[data-qa-media-id="' + id + '"]');
    if (!strook || !doel) return;
    strook.scrollTo({ left: doel.offsetLeft - strook.offsetLeft, behavior: 'smooth' });
    getoondeMedia = id;
  }

  function zetAantal(nieuw) {
    aantal = Math.max(1, Math.min(99, nieuw));
    var el = body.querySelector('[data-qa-aantal]');
    if (el) el.textContent = aantal;
  }

  /* ── Toevoegen ─────────────────────────────────────────────────────── */
  function voegToe(knop) {
    var id = knop.getAttribute('data-qa-variant');
    if (!id) return;
    var knoptekst = knop.querySelector('[data-qa-knoptekst]');
    knop.disabled = true;
    if (knoptekst) knoptekst.textContent = tekst('adding');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: aantal }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('mislukt');
        return r.json();
      })
      .then(function () {
        if (knoptekst) knoptekst.textContent = tekst('added');
        // De lade ververst zichzelf; die functie zet ook het aantal bij.
        if (typeof window.bellascenaRefreshCartDrawer === 'function') {
          window.bellascenaRefreshCartDrawer();
        }
        setTimeout(sluit, 700);
      })
      .catch(function () {
        knop.disabled = false;
        if (knoptekst) knoptekst.textContent = tekst('add_error');
      });
  }

  /* ── Luisteren ─────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bc-qa-open]');
    if (trigger) {
      e.preventDefault();
      open(trigger.getAttribute('data-bc-qa-open'), trigger);
      return;
    }
    if (e.target.closest('[data-qa-close]')) { sluit(); return; }

    var waarde = e.target.closest('.bc-qa__waarde');
    if (waarde && root.contains(waarde)) {
      if (waarde.classList.contains('is-uitverkocht')) return;
      var positie = waarde.getAttribute('data-qa-positie');
      gekozen[positie] = waarde.getAttribute('data-qa-waarde');
      body.querySelectorAll('[data-qa-positie="' + positie + '"]').forEach(function (b) {
        b.classList.toggle('is-gekozen', b === waarde);
      });
      ververs();
      return;
    }

    if (e.target.closest('[data-qa-min]')) { zetAantal(aantal - 1); return; }
    if (e.target.closest('[data-qa-plus]')) { zetAantal(aantal + 1); return; }

    var toevoegen = e.target.closest('[data-qa-toevoegen]');
    if (toevoegen && root.contains(toevoegen) && !toevoegen.disabled) voegToe(toevoegen);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) sluit();
  });
})();
